module.exports = "https://bin.bnbstatic.com/_next/static/images/charity-7df76e61851b2ffde90a44f1bd9896dc.png";